export default "__VITE_ASSET__DJ4$YrHW__"